<template>
  <div class="render-serial">
    <a-space style="margin-bottom: 0.20rem">
      <a-select v-model:value="location" @change="handleUpdatelocation" placeholder="地区" style="width: 80px" allowClear>
        <a-select-option value="长沙">长沙</a-select-option>
        <a-select-option value="广州">广州</a-select-option>
      </a-select>

      <a-select style="width: 130px" placeholder="设备类型" v-model:value="machieType" allowClear
        @change="handleUpdateMachineType" :options="machineTypeOption">
      </a-select>

      <a-select style="width: 120px" placeholder="设备型号" v-model:value="payload.type" allowClear
        @change="updateMachineInfo" :options="machineOptionByType">
      </a-select>
      <a-input @change="checkNumber('batch')" @blur="checkBatch" style="width: 150px" v-model:value="payload.batch"
        placeholder="请输入批次号" allowClear></a-input>
      <div class="letter">{{ letter }}</div>
      <a-input @change="checkNumber('generationTimes')" style="width: 120px" v-model:value="payload.generationTimes"
        placeholder="生成个数" @blur="checkGenerationTimes" allowClear></a-input>
      <a-button @click="renderSerial" :disabled="!isRender" type="primary">生成序列号</a-button>
    </a-space>
    <div class="">
      <a-table :dataSource="serialList" :columns="columns" rowKey="id" :scroll="{ y: 'calc(100vh - 340px)' }"
        :pagination="false">
        <template #isUsed="{ record }">
          <a-tag v-if="record.isUsed" color="#35B7AD">已使用</a-tag>
          <a-tag v-else color="#ec975d">未使用</a-tag>
        </template>

        <template #action="{ record }">
          <a-button @click="updateStatus(record)" type="primary">修改状态</a-button>
        </template>
      </a-table>
      <!-- <div v-for="item in serialList">
      <div>{{ item }}</div>
    </div> -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, computed, createVNode, ref } from "vue";
import { randomSerial, updateserial, exportSerial } from "@/request/view/serial";
import { Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { notice, Toast } from "@/utils";
import {
  machineOption,
  machineTypeOption,
  useMachineSelect,
} from "./options";

export default defineComponent({
  setup(props, content) {
    const serialList = reactive([
    ]);
    const letter = ref("-");

    const location = ref("长沙");

    const { machieType, machineInfo, updateMachineType, updateMachineInfo } =
      useMachineSelect();

    const machineOptionByType = computed(() => {
      if (!machieType.value) return [];
      return machineOption[machieType.value];
    });

    const columns = [
      {
        title: "设备类型",
        align: "center",
        dataIndex: "type",
        key: "type",
        width: 90,
      },
      {
        title: "批次号",
        align: "center",
        dataIndex: "batch",
        key: "batch",
        width: 70,
      },
      {
        title: "设备机身号",
        align: "center",
        dataIndex: "serial",
        key: "serial",
        width: 120,
      },
      {
        title: "使用状态",
        align: "center",
        dataIndex: "isUsed",
        key: "isUsed",
        slots: { customRender: "isUsed" },
        width: 100,
      },
      {
        title: "生成时间",
        align: "center",
        dataIndex: "createDate",
        key: "createDate",
        width: 140,
      },
    ];

    // 请求参数
    const payload = reactive({
      generationTimes: "",
      batch: "",
      type: null,
    });
    // 数字校验
    const checkNumber = (type) => {
      const value = payload[type];
      const numReg = /^[0-9]*$/;
      if (!numReg.test(value)) {
        payload[type] = "";
        Toast("warning", "请输入数字", 3);
        return;
      }

      if (type === "batch" && value.length > 5) {
        payload[type] = "";
        Toast("warning", "批次号格式错误", 3);
        return;
      }

      if (type === "generationTimes" && value.length > 5) {
        payload[type] = "";
        Toast("warning", "序列号个数过大", 3);
        return;
      }
    };
    // 是否可用生成
    const isRender = computed(() => {
      const isType = payload.type !== null;
      const isBatch = payload.batch !== "" && (payload.batch.length === 4 || payload.batch.length === 5);
      const isGenerationTimes = payload.generationTimes !== "";
      return isType && isBatch && isGenerationTimes;
    });

    // 格式校验
    const checkBatch = () => {
      if (payload.batch.length > 5 && payload.batch !== "") {
        payload.batch = "";
        Toast("warning", "批次号格式错误", 3);
      }
    };
    const checkLetter = (type) => {
      let letter = "A";
      const letterBlist = [
        "TE600E",
        "TE600P",
        "TE600H",
        "TE600T",
        "SCX310",
        "TG300S",
      ];
      if (letterBlist.findIndex((item) => item === type) !== -1) {
        letter = "B";
      }
      return letter;
    };
    // 下载excel
    const downExcel = (list) => {
      exportSerial(list).then((res) => {
        console.log(res);
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `设备机身号.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    };
    const renderSerial = () => {
      if (machineInfo.letter === null) return Toast("warning", "请选择型号", 3);


      let letter = machineInfo.letter;

      if (location.value === "广州" && letter === "A") {
        letter = "C";
      } else if (location.value === "广州" && letter === "B") {
        letter = "D";
      }

      randomSerial({
        batch: payload.batch,
        generationTimes: payload.generationTimes,
        letter: letter,
        type: payload.type,
      }).then((res) => {
        let toastType = res.code === 200 ? "success" : "warning";
        Toast(toastType, res.message, 3);
        payload.type = null;
        payload.generationTimes = "";
        payload.batch = "";
        serialList.length = 0;
        if (res.code === 200) {
          downExcel(res.data);
          serialList.push(...res.data);
          content.emit("updateSearchTable");
        }
      });
    };
    const updateSerialStatus = (record) => {
      updateserial({
        id: record.id,
        isUsed: !record.isUsed,
      }).then((res) => {
        record.isUsed = !record.isUsed;
        let toastType = res.code === 200 ? "success" : "warning";
        Toast(toastType, res.message, 3);
        content.emit("renderSerialUpdate", record);
      });
    };
    const updateStatus = (record) => {
      Modal.confirm({
        title: () => "提示",
        icon: () => createVNode(ExclamationCircleOutlined),
        content: () =>
          createVNode(
            "div",
            { style: "color:red;" },
            "是否变更设备序列号使用状态？"
          ),
        onOk() {
          updateSerialStatus(record);
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    };

    const updateRecordUseState = (record) => {
      if (serialList.length === 0) return;
      const targetItem = serialList.find(
        (item) => item.serial === record.serial
      );

      if (targetItem !== undefined) targetItem.isUsed = record.isUsed;
    };

    const checkGenerationTimes = () => {
      if (Number(payload.generationTimes) === 0) {
        payload.generationTimes = "";
        Toast("warning", "生成个数格式错误", 3);
      }
    };

    const handleUpdateMachineType = (e) => {
      updateMachineType(e);
      if (!e) {
        payload.type = null;
      }
    };

    const handleUpdatelocation = (e) => {
       
       if (e === undefined) {
        location.value = "长沙";
       }
       console.log(e, location.value);
    }

    return {
      machieType,
      location,
      machineTypeOption,
      machineOptionByType,
      updateMachineInfo,
      updateMachineType,
      handleUpdateMachineType,
      checkNumber,
      payload,
      checkBatch,
      renderSerial,
      isRender,
      letter,
      serialList,
      columns,
      updateStatus,
      checkGenerationTimes,
      updateRecordUseState,
      handleUpdatelocation,
    };
  },
});
</script>

<style lang="less" scoped>
.letter {
  border-radius: 0.08rem;
  border: 0.01rem solid #d9dce4;
  box-sizing: border-box;
  background: #f2f3f6;
  width: 0.20rem;
  text-align: center;
  cursor: pointer;
}
</style>
